export default __webpack_public_path__ + "static/media/AssetTablerp.bdaadd47.webp";